import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Input, TextArea } from "@vds/inputs";
import { DropdownSelect } from "@vds/selects";
import { Dropdown } from "primereact/dropdown";
import { Col, Grid, Row } from "@vds/grids";
import { Button } from "@vds/buttons";
import { Spacer } from "../../components/core/utility";
import { EditVehicleValidateAddress } from "./EditVehicleValidateAddress";
import {
  getMaterialMappings,
  getReasons,
  updateHardware,
  uploadImage,
  retrieveBundleFiles,
  getExistingHardwareRequest,
  createHardwareRequest,
  updateHardwareRequest,
} from "../../services/C4S Decommission - Replacement/editVehicleWTA";
import { Loader } from "@vds/loaders";
import { BADGE_STYLE, BUNDLE_LIST, HARDWARE_REQUEST_STATUS } from "./EditVehicleConstants";
import { PrivilegeContext } from "../../../context/privilegeContext";
import { getStatesList } from "../../services/C4S Decommission - Replacement/getStatesList";
import { getCountryList } from "../../services/scheduler/getCountryList";
import { Notification } from "@vds/notifications";
import { generate } from "shortid";
import { groupBy, isEqual } from "lodash";
import { handleChangePage, switchTab } from "./../C4S Decommission - Replacement/utils";
import { Icon } from "@vds/icons";

import VehicleImageUpload from "./../../components/core/CustomUploadFile/CustomUploadFile";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { ViewVehicleList } from "../../services/C4S Decommission - Replacement/viewVehicleList";
import { messageBus } from "../../../../src/utility/messageBus";
import AddMaterial from "./AddMaterial";
import { getContractDetails } from "../../services/C4S Decommission - Replacement/getMMIDList";
import styled from "styled-components";
import "./EditVehicleWTAComponent.css";
import { Checkbox } from "primereact/checkbox";

export const CustomisedDropdown = styled(Dropdown)`
  border: 1px solid #6f7171 !important;
  font-family: Verizon-NHG-eTX;
  width: 100%;
  box-shadow: none !important;
  font-size: 16px !important;
  color: #000000 !important;
`;

const StyledCheckbox = styled(Input)`
  margin-top: 0.5rem;
  font-weight: 100;
  font-size: 14px !important;
`;

const formattedMaterialMapping = (materialMapping, recommendations) => {
  const actionableEntries = recommendations.filter((e) => e.isActionable);
  let selectedMaterials = {};
  const updatedMaterialMapping = materialMapping.reduce((acc, cur) => {
    const { subscriptionId, hardwareId } = cur;
    const matchingActionableEntry = actionableEntries.find(
      (e) => e.subscriptionId === subscriptionId && e.materials.find((m) => m.materialId === hardwareId)
    );
    if (matchingActionableEntry) {
      acc.push({
        ...cur,
        materials: matchingActionableEntry.materials,
        isActionable: matchingActionableEntry.isActionable,
        savedMaterial: matchingActionableEntry.savedMaterial || cur.hardwareId,
      });
      selectedMaterials[cur.id] = matchingActionableEntry.savedMaterial || cur.hardwareId;
    } else acc.push(!cur.materials ? { ...cur, materials: [{ materialId: cur.hardwareId, materialName: cur.hardwareName }] } : cur);
    return acc;
  }, []);
  return { updatedMaterialMapping, selectedMaterials };
};

const EditVehicleWTAComponent = ({ data, bundleName, bundleId, bundleData, setModalOpened, assetType }) => {
  const origData = useRef({ ...data, materialMapping: [...data.materialMapping] });
  const [vehicleDetails, setVehicleDetails] = useState({
    ...data,
    materialMapping: data.materialMapping.map((item) => {
      return {
        ...item,
        materials: [{ materialId: item.hardwareId, materialName: item.hardwareName }],
      };
    }),
  });
  const { cspInfo, setAlertModal } = useContext(PrivilegeContext);
  const [reasonSelected, setReasonSelected] = useState(data.reason || null);
  const reasonForNonPriority1Ref = useRef(null);
  const [notification, setNotification] = useState(null);
  const notificationTimeoutRef = useRef(null);
  const notificationInteractionRef = useRef(false);
  const defaultPriority = data.priority || 1;
  const [materialsAndPriorities, setMaterialsAndPriorities] = useState();
  const [hardwareSelected, setHardwareSelected] = useState(null);
  const [contact, setContact] = useState(data.contact);
  const [email, setEmail] = useState(data.email);
  const [phone, setPhone] = useState(data.phone);
  const [vehicleData, setVehicleData] = useState([]);
  const [hardwares, setHardwares] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [commentText, setCommentText] = useState(data.comment);
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const [isFieldsChanged, setIsFieldsChanged] = useState(false);
  const [originalFormValues, setOriginalFormValues] = useState(null);
  const [isCriticalFieldsChanged, setIsCriticalFieldsChanged] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [selectedMaterialsFromDropdown, setSelectedMaterialsFromDropdown] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [hardwareRequestInitiated, setHardwareRequestInitiated] = useState(false);
  const [requestedHardwareFromDropdown, setRequestedHardwareFromDropdown] = useState({});
  const [reasonForChangingRecommendation, setReasonForChangingRecommendation] = useState("");
  const [hardwareChangeComment, setHardwareChangeComment] = useState("");
  const [isAddMaterialModalOpen, setIsAddMaterialModalOpen] = useState(false);
  const [existingHardwareRequest, setExistingHardwareRequest] = useState(null);
  const [addedMaterials, setAddedMaterials] = useState([]);
  const [isRequestedHardwareChanged, setIsRequestedHardwareChanged] = useState(false);
  const [isNoRecommendationCase, setIsNoRecommendationCase] = useState(false);
  const [requestedMaterialList, setRequestedMaterialList] = useState({});
  const [isStartRequestDisabled, setIsStartRequestDisabled] = useState(
    vehicleDetails.materialMapping.every((item) => item.status?.toLowerCase() === "submitted")
  ); //button disabled when material status is submitted
  const [doNotShipCheckboxSelected, setDoNotShipCheckboxSelected] = useState(!!data?.isShippingBlocked);

  const originalDoNotShip = useRef(!!data?.isShippingBlocked);
  const isDoNotShipChanged = doNotShipCheckboxSelected !== originalDoNotShip.current;

  useEffect(() => {
    // Sync checkbox with incoming prop if it changes
    if (typeof data?.isShippingBlocked !== "undefined") {
      setDoNotShipCheckboxSelected(!!data.isShippingBlocked);
    }
  }, [data?.isShippingBlocked]);

  // Helper function to check if there are no valid recommendations
  const hasNoValidRecommendations = () => {
    return !hardwares || hardwares.length === 0;
  };

  const handleFileUpload = async (files) => {
    const vehicleId = data.vehicle;
    // Check if 'files' is indeed an array, and iterate over it
    if (!Array.isArray(files)) {
      // If only a single file is passed, wrap it in an array for consistent processing
      files = [files];
    }

    for (const file of files) {
      // Iterate over each individual file
      // Ensure file.name exists before using it in the URL
      if (!file || !file.name) {
        continue; // Skip to the next file if this one is invalid
      }

      try {
        // Call the uploadImage service function with the correct parameters:
        // vehicleId, bundleId, and the actual file object.
        const response = await uploadImage(vehicleId, bundleId, file);

        if (response.status >= 200 && response.status < 300) {
          // Check for success status codes (2xx)
          // eslint-disable-next-line
        } else {
          // eslint-disable-next-line
        }
      } catch (error) {
        // Catch network errors or errors re-thrown from the service function
        // eslint-disable-next-line
        // setHasImages(false); // Adjust based on your error handling for multiple files
      }
    }
  };
  const prepareHardwareApiPayload = () => {
    if (!cspInfo?.data?.data) return null;

    const cspData = cspInfo.data.data;
    const products = cspData.Product || [];

    const coreProducts = products.filter(
      (product) => product.BundleId === bundleId && product.featureType === "CORE" && product.AssetType.toLowerCase() === assetType.toLowerCase()
    );

    if (!coreProducts.length) return null;

    const payload = {
      vinList: [
        {
          id: data.id,
          vin: data.vehicle,
          year: data.year,
          make: data.make,
          model: data.model,
          killSwitch: data.killSwitch,
          emergency: data.emergency,
          wheelChair: data.wheelChair,
          weightClass: data.weightClass,
          fuelType: data.fuelType,
        },
      ],
      type: data.vehicle.startsWith("VIN") ? "YMM" : data.vehicle.startsWith("AST") ? "ASSET" : "VEHICLE",
      countryCode: cspData.BillingCountry,
      salesOrgId: cspData.CSP?.[0]?.Opp_Sales_Org,
      productPlatform: cspData.ProductPlatform,
      accountBrand: cspData.Account_Brand,
      createdBy: `${cspData?.firstName} ${cspData?.lastName}`,
      vehicleSubscriptions: [],
    };
    const subscriptions = {};

    coreProducts.forEach((product) => {
      const subscription = product.SAPProductID;
      const techRefId = product.TechRefId;

      if (!subscriptions[subscription]) {
        subscriptions[subscription] = {
          subscription,
          techRefId,
          vehicleFeatures: [],
        };
      }

      const features = products.filter(
        (p) => p.BundleId === product.BundleId && p.featureType === "FEATURE" && p.AssetType.toLowerCase() === assetType.toLowerCase()
      );

      features.forEach((feature) => {
        subscriptions[subscription].vehicleFeatures.push({
          materialId: feature.SAPProductID,
          techRefId: feature.TechRefId,
        });
      });
    });

    payload.vehicleSubscriptions = Object.values(subscriptions);
    return payload;
  };

  useEffect(() => {
    const fetchHardwares = async () => {
      try {
        setIsLoading(true);
        setIsTableLoading(true);
        const reasonsResponse = await getReasons("RECOMM_CHANGE_REASONS");
        const existingHardware = await getExistingHardwareRequest(data.id);
        const materialResponse = await getMaterialMappings(prepareHardwareApiPayload());
        const countriesResponse = await getCountryList();
        const statesResponse = await getStatesList();

        const requestEntry = existingHardware?.data?.data?.requests?.find((e) => e.status.toLowerCase() !== "cancelled");
        setExistingHardwareRequest(requestEntry || null);

        if (requestEntry) {
          setHardwareRequestInitiated(true);
          setReasonForChangingRecommendation(requestEntry.reasonForChange || "");
          setHardwareChangeComment(requestEntry.deploymentAgentComments || "");

          const partRecommendationResponse = materialResponse?.data?.data.map((entry) => {
            return {
              ...entry,
              recommendations: entry?.recommendations?.map((rec, index) => ({
                ...rec,
                id: generate(), // Generate a unique ID for each recommendation
              })),
            };
          });
          setMaterialsAndPriorities(partRecommendationResponse);
          let hardwareList = [];
          if (materialResponse?.data?.data && materialResponse.data.data.length > 0) {
            const hasPriorityZero = materialResponse.data.data.some((device) => device.priority === "0" || device.priority === 0);

            if (hasPriorityZero) {
              hardwareList = [];
            } else {
              hardwareList =
                materialResponse.data.data && materialResponse.data.data.length && materialResponse.data.data[0].priority
                  ? materialResponse.data.data
                      .map((device, index) => ({
                        id: index + 1,
                        value: device.deviceType,
                        label: `${device.deviceType} (Priority: ${device.priority || "1"})`,
                        priority: device.priority ? parseInt(device.priority, 10) : 1,
                      }))
                      .sort((a, b) => a.priority - b.priority)
                  : [];
            }

            setHardwares(hardwareList);

            const priorityToMatch = parseInt(data.priority || defaultPriority, 10);
            const matchingHardware = hardwareList.find((h) => h.priority === priorityToMatch);

            if (matchingHardware && data.vehicleStatus !== "Warning") {
              setHardwareSelected(matchingHardware.value);
            } else if (hardwareList.length > 0) {
              setHardwareSelected(hardwareList[0].value);
            }
          }
        } else {
          //Append ID to each recommendation for uniqueness
          const partRecommendationResponse = materialResponse?.data?.data.map((entry) => {
            return {
              ...entry,
              recommendations: entry?.recommendations?.map((rec, index) => ({
                ...rec,
                id: generate(), // Generate a unique ID for each recommendation
              })),
            };
          });
          setMaterialsAndPriorities(partRecommendationResponse);
          let hardwareList = [];
          if (materialResponse?.data?.data && materialResponse.data.data.length > 0) {
            // If any device has priority "0", set hardware list to empty
            const hasPriorityZero = materialResponse.data.data.some((device) => device.priority === "0" || device.priority === 0);

            if (hasPriorityZero) {
              hardwareList = [];
              const allSavedMaterialsNullOrUndefined = vehicleDetails.materialMapping.every(
                (item) => item.hardwareId == null // checks for null or undefined
              );
              setIsNoRecommendationCase(allSavedMaterialsNullOrUndefined);
            } else {
              hardwareList =
                materialResponse.data.data && materialResponse.data.data.length && materialResponse.data.data[0].priority
                  ? materialResponse.data.data
                      .map((device, index) => ({
                        id: index + 1,
                        value: device.deviceType,
                        label: `${device.deviceType} (Priority: ${device.priority || "1"})`,
                        priority: device.priority ? parseInt(device.priority, 10) : 1,
                      }))
                      .sort((a, b) => a.priority - b.priority)
                  : [];
            }
            setHardwares(hardwareList);

            const priorityToMatch = parseInt(data.priority || defaultPriority, 10);
            const matchingHardware = hardwareList.find((h) => h.priority === priorityToMatch);

            if (matchingHardware && data.vehicleStatus !== "Warning") {
              setHardwareSelected(matchingHardware.value);
              const firstDeviceData = partRecommendationResponse.find((device) => device.deviceType === matchingHardware.value);
              if (firstDeviceData && firstDeviceData.recommendations) {
                const { updatedMaterialMapping, selectedMaterials } = formattedMaterialMapping(
                  vehicleDetails.materialMapping,
                  firstDeviceData.recommendations
                );
                setVehicleDetails((prev) => {
                  return { ...prev, materialMapping: updatedMaterialMapping };
                });
                setSelectedMaterialsFromDropdown(selectedMaterials);
              }
            } else if (hardwareList.length > 0) {
              setHardwareSelected(hardwareList[0].value);

              const firstDeviceData = partRecommendationResponse.find((device) => device.deviceType === hardwareList[0].value);

              if (firstDeviceData && firstDeviceData.recommendations) {
                const groupBySubscriptionId = groupBy(vehicleDetails.materialMapping, "subscriptionId");
                const updatedMaterialMapping =
                  data.priority !== null && vehicleDetails.materialMapping.length
                    ? Object.keys(groupBySubscriptionId).reduce((acc, key) => {
                        const listOfsubscriptions = groupBySubscriptionId[key];
                        const recommendations = firstDeviceData.recommendations.filter((e) => e.subscriptionId === key);
                        acc.push({
                          ...listOfsubscriptions[0],
                          materials: recommendations[0].materials || [
                            { materialId: listOfsubscriptions[0].hardwareId, materialName: listOfsubscriptions[0].hardwareName },
                          ],
                          isActionable: recommendations[0].isActionable || false,
                          savedMaterial: recommendations[0].savedMaterial || listOfsubscriptions[0].hardwareId,
                        });
                        if (listOfsubscriptions.length > 1 && recommendations.length > 1) {
                          acc.push({
                            ...listOfsubscriptions[1],
                            materials: recommendations[1].materials || [
                              { materialId: listOfsubscriptions[1].hardwareId, materialName: listOfsubscriptions[0].hardwareName },
                            ],
                            isActionable: recommendations[1].isActionable || false,
                            savedMaterial: recommendations[1].savedMaterial || listOfsubscriptions[1].hardwareId,
                          });
                        }
                        return acc;
                      }, [])
                    : firstDeviceData.recommendations;
                const savedDrodpownEntries = firstDeviceData.recommendations.filter((e) => e.isActionable && !!e.savedMaterial);
                if (savedDrodpownEntries.length) {
                  const savedMaterials = savedDrodpownEntries.reduce((acc, entry) => {
                    acc[entry.id] = entry.savedMaterial;
                    return acc;
                  }, {});
                  setSelectedMaterialsFromDropdown(savedMaterials);
                }
                setVehicleDetails((prev) => {
                  return { ...prev, materialMapping: updatedMaterialMapping };
                });
                const allSavedMaterialsNullOrUndefined = updatedMaterialMapping.every(
                  (item) => item.savedMaterial == null // checks for null or undefined
                );
                setIsNoRecommendationCase(allSavedMaterialsNullOrUndefined);
              }
            }
          } else {
            const allSavedMaterialsNullOrUndefined = vehicleDetails.materialMapping.every(
              (item) => item.hardwareId == null // checks for null or undefined
            );
            setIsNoRecommendationCase(allSavedMaterialsNullOrUndefined);
          }
        }

        if (reasonsResponse?.data) {
          const reasonsList = reasonsResponse.data.data.map((reason) => ({
            id: reason.id,
            value: reason.id,
            label: reason.description,
          }));
          setReasons(reasonsList);
          if (data.reason) {
            const matchingReason = reasonsList.find((r) => r.id === data.reason || r.value === data.reason);
            if (matchingReason) {
              setReasonSelected(matchingReason.value);
            }
          }
        }
        if (countriesResponse?.data?.data) {
          setAddress((prevState) => ({
            ...prevState,
            country: {
              ...prevState.country,
              options: countriesResponse.data.data,
            },
          }));
        }

        if (statesResponse?.data?.data) {
          let allStateOptions = statesResponse.data.data.map((state) => ({
            ...state,
            stateName: state.erpStateCode + " - " + state.stateCode,
          }));
          const groupedStateOptions = groupBy(allStateOptions, "countryCode");

          setAddress((prevState) => ({
            ...prevState,
            state: {
              ...prevState.state,
              allStateOptions: groupedStateOptions,
              options: groupedStateOptions["USA"],
            },
          }));
        }
      } catch (error) {
        // error handling
      } finally {
        setIsLoading(false);
        setIsTableLoading(false);
      }
    };

    fetchHardwares();
  }, []);

  useEffect(() => {
    if (
      (!isLoading && hardwares.length > 0 && reasons.length > 0 && !originalFormValues) ||
      (data.vehicle.startsWith("AST") && !originalFormValues)
    ) {
      setOriginalFormValues({
        hardware: hardwareSelected,
        contact: contact || "",
        phone: phone || "",
        email: email || "",
        reason: reasonSelected,
        address: [
          bundleData.address,
          bundleData.address1 ? bundleData.address1 : null,
          bundleData.city,
          bundleData.stateCode,
          bundleData.zipCode,
          bundleData.countryCode,
        ]
          .filter((item) => item !== null && item !== "")
          .join(", "),
      });
    }
    if (!isLoading && !originalFormValues?.selectedMaterialsFromDropdown && Object.keys(selectedMaterialsFromDropdown).length > 0) {
      setOriginalFormValues((prev) => ({
        ...prev,
        selectedMaterialsFromDropdown: { ...selectedMaterialsFromDropdown },
      }));
    }
  }, [isLoading, hardwares.length, reasons.length, hardwareSelected, reasonSelected, selectedMaterialsFromDropdown, address]);

  useEffect(() => {
    if (!originalFormValues) return;

    const hardwareChanged = hardwareSelected !== originalFormValues.hardware;
    const contactChanged = contact !== originalFormValues.contact;
    const phoneChanged = phone !== originalFormValues.phone;
    const emailChanged = email !== originalFormValues.email;
    const reasonChanged = reasonSelected !== originalFormValues.reason;
    const addressChanged = (() => {
      if (!originalFormValues.address) return false;
      if (isFieldsChanged) {
        const currentAddress = [
          address.address1.value,
          address.address2.value,
          address.city.value,
          address.state.value?.erpStateCode,
          address.zip.value,
          address.country.value?.code,
        ]
          .filter((item) => item !== null && item !== "")
          .join(", ");
        return currentAddress !== originalFormValues.address;
      } else return false;
    })();

    const selectedHardwareInfo = hardwares.find((h) => h.value === hardwareSelected);
    const isPriority1 = selectedHardwareInfo && selectedHardwareInfo.priority === 1;

    const isDropdownExists =
      materialsAndPriorities?.find((device) => device.deviceType === hardwareSelected)?.recommendations?.filter((e) => e.isActionable).length ||
      false;

    // when there is a dropdown and changes in dropdown values selection
    const isMaterialDropdownChanged =
      isDropdownExists &&
      (vehicleDetails.vehicleStatus !== "Warning"
        ? !isEqual(selectedMaterialsFromDropdown, originalFormValues.selectedMaterialsFromDropdown || {})
        : Object.keys(selectedMaterialsFromDropdown).length > 0);

    // when vehicle status is warning and new recommendations are added we should allow to save
    const isMaterialsChanged = !existingHardwareRequest && !isDropdownExists && vehicleDetails.vehicleStatus === "Warning";

    const anyFieldChanged =
      hardwareChanged ||
      contactChanged ||
      phoneChanged ||
      emailChanged ||
      (!isPriority1 && reasonChanged) ||
      isMaterialDropdownChanged ||
      isMaterialsChanged ||
      addressChanged;
    setIsCriticalFieldsChanged(anyFieldChanged);
  }, [hardwareSelected, contact, phone, email, reasonSelected, hardwares, selectedMaterialsFromDropdown, vehicleDetails.vehicleStatus, address]);

  useEffect(() => {
    if (existingHardwareRequest) return;

    const currentHardwareMap = vehicleDetails.materialMapping.reduce((acc, cur) => {
      const { isActionable = false, savedMaterial, materials, id } = cur;
      if (isActionable && (selectedMaterialsFromDropdown[id] || savedMaterial)) {
        // filtering non selected in requested hardware
        acc[id] = selectedMaterialsFromDropdown[id] || savedMaterial;
      } else if (!isActionable) {
        acc[id] = materials[0].materialId;
      }
      return acc;
    }, {});
    const isRequestedHardwareChanged = !isEqual(currentHardwareMap, requestedHardwareFromDropdown) || !!addedMaterials.length;
    setIsRequestedHardwareChanged(isRequestedHardwareChanged);
  }, [requestedHardwareFromDropdown, addedMaterials, vehicleDetails.materialMapping, selectedMaterialsFromDropdown, existingHardwareRequest]);

  const refetchVehicleData = async () => {
    // Refetch the data to ensure the UI is in sync
    setIsTableLoading(true);
    const updatedVehicleDetails = await ViewVehicleList(
      bundleId,
      undefined,
      undefined,
      cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
      vehicleDetails.vehicle
    );
    if (updatedVehicleDetails.status === 200 && updatedVehicleDetails.data?.data) {
      const vehicleData = updatedVehicleDetails.data?.data?.vehicles[`${bundleId}`];
      const deviceData = materialsAndPriorities?.find((device) => device.deviceType === hardwareSelected);
      let selectedMaterials = {};

      if (deviceData && deviceData.recommendations.length > 0) {
        const formattedData = formattedMaterialMapping(vehicleData[0].materialMapping, deviceData.recommendations);
        setVehicleDetails({ ...vehicleData[0], materialMapping: formattedData.updatedMaterialMapping });
        setSelectedMaterialsFromDropdown(formattedData.selectedMaterials);
        setIsStartRequestDisabled(formattedData.updatedMaterialMapping.every((item) => item.status?.toLowerCase() === "submitted"));
        selectedMaterials = formattedData.selectedMaterials;
      } else {
        setVehicleDetails({
          ...vehicleData[0],
          materialMapping: vehicleData[0].materialMapping.map((item) => ({
            ...item,
            materials: [{ materialId: item.hardwareId, materialName: item.hardwareName }],
          })),
        });
        setIsStartRequestDisabled(vehicleData[0].materialMapping.every((item) => item.status?.toLowerCase() === "submitted"));
      }

      // **KEY FIX**: Update the form's baseline state after a successful save.
      setOriginalFormValues({
        hardware: hardwareSelected,
        contact: contact || "",
        phone: phone || "",
        email: email || "",
        reason: reasonSelected,
        selectedMaterialsFromDropdown: { ...selectedMaterials },
        address: [
          address.address1.value,
          address.address2.value,
          address.city.value,
          address.state.value?.erpStateCode,
          address.zip.value,
          address.country.value?.code,
        ]
          .filter((item) => item !== null && item !== "")
          .join(", "),
      });
      setIsCriticalFieldsChanged(false); // Disable save button until next edit
    } else {
      notify("Failed to refresh vehicle data.", "error");
    }
    setIsTableLoading(false);
  };

  const handleClick = async () => {
    // --- 1. VALIDATION ---
    // This section remains the same.
    if (!data.vehicle.startsWith("AST")) {
      if (!hardwareSelected || hardwareSelected === "") {
        notify("Please select hardware", "error");
        return;
      }

      const selectedHardwareInfo = hardwares.find((h) => h.value === hardwareSelected);
      const priority = selectedHardwareInfo ? selectedHardwareInfo.priority : defaultPriority;

      if (priority !== 1 && (!reasonSelected || reasonSelected === "Select Reason")) {
        notify("Please select a reason", "error");
        return;
      }
    }
    if (!contact || contact.trim() === "") {
      notify("Please enter a contact name", "error");
      return;
    }
    if (!phone || phone.trim() === "") {
      notify("Please enter a phone number", "error");
      return;
    }
    if (!email || email.trim() === "") {
      notify("Please enter an email address", "error");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      notify("Please enter a valid email address", "error");
      return;
    }
    const phoneRegex = /^(\(\d{3}\)\s?\d{3}-\d{4}|\d{10})$/;
    if (!phoneRegex.test(phone)) {
      notify("Please enter a valid phone number", "error");
      return;
    }

    if (address.address1.error || address.city.error || address.state.error || address.country.error || address.zip.error) {
      notify("Please enter a valid address", "error");
      return;
    }
    if (
      Object.keys(selectedMaterialsFromDropdown).length !==
      materialsAndPriorities?.find((device) => device.deviceType === hardwareSelected)?.recommendations?.filter((e) => e.isActionable).length
    ) {
      notify("Please select material from the dropdown", "error");
      return;
    }

    // --- 2. API CALL AND STATE MANAGEMENT ---
    setIsLoading(true);
    setIsSaving(true); // Set saving state to true at the beginning

    try {
      const selectedHardwareInfo = hardwares.find((h) => h.value === hardwareSelected);
      const priority = selectedHardwareInfo ? selectedHardwareInfo.priority : defaultPriority;

      const bundleOrderType = cspInfo?.data?.data?.Product?.find((p) => p.BundleId === bundleId)?.OrderDetailType;
      // The payload object remains the same as in your original code.
      const payload = {
        id: data.id ? parseInt(data.id, 10) : null,
        vin: data.vehicle,
        isAddressUpdated: isFieldsChanged,
        addressId: bundleData.addressId,
        address1: address.address1.value,
        address2: address.address2.value,
        city: address.city.value,
        country: address.country.value?.code,
        countryCode: address.country.value?.code,
        stateCode: address.state.value?.erpStateCode,
        zipCode: address.zip.value,
        timezone: address.timezone,
        addressByPass: address.addressByPass,
        locationFound: address.locationFound,
        locusLocationId: address.locusLocationId,
        latitude: address.latitude,
        longitude: address.longitude,
        locusSuggestedAddress: address.locusSuggestedAddress,
        contactId: bundleData.contactId,
        customerName: contact,
        customerEmail: email,
        customerPhone: phone,
        modifiedBy: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
        salesOrgId: cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org,
        crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
        bundleId: bundleId,
        isShippingBlocked: doNotShipCheckboxSelected,
        bundleOrderType: vehicleDetails.materialMapping.length ? vehicleDetails.materialMapping[0].orderType : bundleOrderType,
        ...(data.vehicle.startsWith("AST")
          ? {}
          : {
              reasonForChanging: priority === 1 ? null : reasonSelected ? parseInt(reasonSelected, 10) : null,
              hardwareSelected: hardwareSelected,
              hardwarePriority: priority,
              isHardwareChange: vehicleDetails.priority === null && hardwareSelected ? true : hardwareSelected !== originalFormValues.hardware,
            }),
        vehicleSubscriptions:
          hardwareSelected === originalFormValues.hardware && !!origData.current.materialMapping.length && vehicleDetails.priority !== null
            ? vehicleDetails.materialMapping.map((item) => ({
                id: item.id,
                subscriptionName: item.subscriptionName,
                subscriptionId: item.subscriptionId || null,
                techRefId: item.techRefId || null,
                ...(!item.isActionable
                  ? {
                      materialId: item.materials[0].materialId || null,
                      materialName: item.materials[0].materialName || null,
                      isActionableChanged: false,
                    }
                  : {
                      materialId: selectedMaterialsFromDropdown[item.id],
                      materialName: item.materials.find((m) => m.materialId === selectedMaterialsFromDropdown[item.id])?.materialName || null,
                      isActionableChanged: true,
                    }),
                comment: commentText,
                quantity: item.quantity,
              }))
            : [
                ...origData.current.materialMapping.map((item) => ({
                  id: item.id,
                  subscriptionName: item.subscriptionName,
                  subscriptionId: item.subscriptionId || null,
                  techRefId: item.techRefId || null,
                  materialId: item.hardwareId || null,
                  materialName: item.hardwareName || null,
                  comment: commentText,
                  quantity: item.quantity,
                })),
                ...vehicleDetails.materialMapping
                  .filter((item) => !origData.current.materialMapping.some((orig) => orig.id === item.id))
                  .map((item) => ({
                    subscriptionName: item.subscriptionName,
                    subscriptionId: item.subscriptionId || null,
                    techRefId: item.techRefId || null,
                    ...(!item.isActionable
                      ? {
                          materialId: item.materials[0].materialId || null,
                          materialName: item.materials[0].materialName || null,
                          isActionableChanged: false,
                        }
                      : {
                          materialId: selectedMaterialsFromDropdown[item.id],
                          materialName: item.materials.find((m) => m.materialId === selectedMaterialsFromDropdown[item.id])?.materialName || null,
                          isActionableChanged: true,
                        }),
                    comment: commentText,
                    quantity: item.quantity,
                  })),
              ],
      };

      const response = await updateHardware(payload, parseInt(data.id, 10));

      if (response?.status === 200) {
        notify("Vehicle updated successfully!", "success");
        await refetchVehicleData();
      } else {
        notify(response?.data?.message || "Vehicle Update Failed", "error");
      }
    } catch (error) {
      notify(error?.response?.data?.message || "An unexpected error occurred.", "error");
    } finally {
      setIsLoading(false);
      setIsTableLoading(false);
      // **KEY FIX**: Set isSaving back to false to allow future interactions.
      setIsSaving(false);
    }
  };

  useEffect(() => {
    return () => {
      if (notificationTimeoutRef.current) {
        clearTimeout(notificationTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleUserInteraction = () => {
      if (notification && notificationInteractionRef.current) {
        setNotification(null);
        if (notificationTimeoutRef.current) {
          clearTimeout(notificationTimeoutRef.current);
          notificationTimeoutRef.current = null;
        }
      }

      const interactionTimer = setTimeout(() => {
        notificationInteractionRef.current = true;
      }, 1000);

      document.addEventListener("click", handleUserInteraction);
      document.addEventListener("input", handleUserInteraction);
      document.addEventListener("change", handleUserInteraction);

      return () => {
        document.removeEventListener("click", handleUserInteraction);
        document.removeEventListener("input", handleUserInteraction);
        document.removeEventListener("change", handleUserInteraction);
        clearTimeout(interactionTimer);
      };
    };
  }, [notification]);

  const notify = (content, type) => {
    if (notificationTimeoutRef.current) {
      clearTimeout(notificationTimeoutRef.current);
      notificationTimeoutRef.current = null;
    }

    notificationInteractionRef.current = false;

    setNotification(
      <>
        <Notification
          key={generate()}
          type={type}
          title={content}
          fullBleed={true}
          onClose={() => {
            if (notificationTimeoutRef.current) {
              clearTimeout(notificationTimeoutRef.current);
              notificationTimeoutRef.current = null;
            }
            setNotification(null);
          }}
          dismissible={true}
        />
        <br />
      </>
    );

    if (type !== "error") {
      notificationTimeoutRef.current = setTimeout(() => {
        setNotification(null);
        notificationTimeoutRef.current = null;
      }, 5000);
    }
  };

  const createHardwareRequestHandler = async () => {
    const ids = Object.keys(
      Object.entries(requestedHardwareFromDropdown).reduce((acc, [key, value]) => {
        if (value !== "selectHardware") {
          acc[key] = value;
        }
        return acc;
      }, {})
    );
    const requestedMapping = vehicleDetails.materialMapping
      .filter((item) => ids.includes(item.id))
      .map((item) => ({
        subscriptionName: item.subscriptionName,
        subscriptionId: item.subscriptionId,
        techRefId: item.techRefId,
        materialId: requestedHardwareFromDropdown[item.id] || null,
        materialName:
          item.materials.find((m) => m.materialId === requestedHardwareFromDropdown[item.id])?.materialName ||
          (requestedMaterialList[Number(item.subscriptionId)] || []).find((m) => m.materialId === requestedHardwareFromDropdown[item.id])
            ?.materialName,
        deviceType: hardwareSelected,
      }));
    if (addedMaterials.length) {
      requestedMapping.push(
        ...addedMaterials.map(({ subscriptionId, subscriptionName, techRefId, materialId, materialName }) => ({
          subscriptionId,
          subscriptionName,
          techRefId,
          materialId,
          materialName,
          deviceType: hardwareSelected,
        }))
      );
    }

    const bundleOrderType = cspInfo?.data?.data?.Product?.find((p) => p.BundleId === bundleId)?.OrderDetailType;

    const payload = {
      bundle: bundleId,
      action: "CREATE",
      order: cspInfo?.data?.data?.CSP?.[0]?.Provider_Order,
      crmRefId: cspInfo?.data?.data?.CSP?.[0]?.CRM_Ref_ID,
      cspId: cspInfo?.data?.data?.CSP?.[0]?.CSPID,
      accountName: cspInfo?.data?.data?.AccountName,
      vehicleId: data.id ? parseInt(data.id, 10) : null,
      deploymentAgent: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
      salesOrgId: cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org,
      bundleOrderType: vehicleDetails.materialMapping.length ? vehicleDetails.materialMapping[0].orderType || bundleOrderType : bundleOrderType,
      requestedHardwareMapping: requestedMapping,
      reasonForChange: isNoRecommendationCase ? "NA" : reasonForChangingRecommendation,
      deploymentAgentComments: hardwareChangeComment,
    };
    const response = await createHardwareRequest(payload);
    if (response?.status === 200) {
      setIsTableLoading(true);
      setExistingHardwareRequest(response.data.data[0]);
      setVehicleDetails((prev) => ({ ...prev, vehicleStatus: "Warning" }));
      setIsTableLoading(false);
    }
  };

  const updateHardwareRequestHandler = async (action) => {
    if (!existingHardwareRequest && action === "USER_CANCEL") {
      setExistingHardwareRequest(null);
      setAddedMaterials([]);
      setRequestedHardwareFromDropdown({});
      setHardwareRequestInitiated(false);
      await refetchVehicleData();
      return;
    }
    const payload = {
      action,
      deploymentAgent: `${cspInfo?.data?.data?.firstName} ${cspInfo?.data?.data?.lastName}`,
    };
    const response = await updateHardwareRequest(payload, existingHardwareRequest.id);
    if (response?.status === 200) {
      setExistingHardwareRequest(action === "USER_CANCEL" ? null : response.data.data[0]);
      setAddedMaterials([]);
      setRequestedHardwareFromDropdown({});
      setHardwareRequestInitiated(false);
      await refetchVehicleData();
    }
  };

  const subscriptionTableBody = useMemo(() => {
    if (vehicleDetails.materialMapping.length === 0) return {};
    const final = [];
    const groupBySubscriptionId = groupBy(vehicleDetails.materialMapping, "subscriptionId");
    Object.keys(groupBySubscriptionId).forEach((key) => {
      const filterNullTypes = groupBySubscriptionId[key].filter((item) => !!item.type);
      let type = filterNullTypes.length > 0 ? filterNullTypes[0].type : "--";
      if (type !== "--") {
        if (type?.toLowerCase() === "core") {
          type = "Core";
        } else if (type?.toLowerCase() === "companion") {
          type = "Companion";
        } else if (type?.toLowerCase() === "feature") {
          type = "Feature";
        }
      }
      final.push({
        type,
        subscriptionName: groupBySubscriptionId[key][0].subscriptionName || "—",
        subscriptionId: groupBySubscriptionId[key][0].subscriptionId,
        techRefId: groupBySubscriptionId[key][0].techRefId,
        hardware: groupBySubscriptionId[key],
      });
    });

    const desiredOrder = ["Core", "Companion", "Feature"];

    final.sort((a, b) => {
      const aIndex = desiredOrder.indexOf(a.type);
      const bIndex = desiredOrder.indexOf(b.type);
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
    });
    return final;
  }, [vehicleDetails.materialMapping]);

  const renderHardwareDetails = (rowData) => {
    if (!rowData.hardware || rowData.hardware.length === 0) {
      return "-";
    }
    const { hardware } = rowData;

    return hardware.map((item, itemIndex) => {
      const { isActionable = false, materials = [], savedMaterial } = item;
      if (!isActionable) {
        return (
          <div key={itemIndex} style={{ marginTop: "12px", marginBottom: "12px", fontFamilt: "Verizon-NHG-eDS", height: "44px" }}>
            {materials[0].materialName} {materials[0].materialId ? `(${materials[0].materialId})` : ""}
          </div>
        );
      } else if (isActionable && hardwareRequestInitiated) {
        const materialId = selectedMaterialsFromDropdown[item.id] || savedMaterial;
        const material = materialId ? materials.find((m) => m.materialId === materialId) : null;

        return (
          <div key={itemIndex} style={{ marginTop: "12px", marginBottom: "12px", fontFamilt: "Verizon-NHG-eDS", height: "44px" }}>
            {material ? `${material.materialName} (${material.materialId})` : ""}
          </div>
        );
      } else {
        return (
          <div key={item.id} style={{ width: "410px", marginBottom: "10px", ...(itemIndex !== 0 ? { marginTop: "10px" } : {}) }}>
            <DropdownSelect
              name={`material-${item.id}`}
              key={item.id}
              style={!selectedMaterialsFromDropdown[item.id] && !savedMaterial ? { borderBottom: "4px solid #EE0000" } : {}}
              label=""
              value={selectedMaterialsFromDropdown[item.id] || savedMaterial || "Select Hardware"}
              onChange={(e) => {
                setSelectedMaterialsFromDropdown((prev) => {
                  return {
                    ...prev,
                    [item.id]: e.target.value,
                  };
                });
              }}
            >
              <option disabled>Select Hardware</option>
              {materials.map((m) => {
                return (
                  <option key={m.materialId} value={m.materialId}>
                    {m.materialName} ({m.materialId})
                  </option>
                );
              })}
            </DropdownSelect>
          </div>
        );
      }
    });
  };

  const renderRequestedardware = (rowData) => {
    const { hardware, subscriptionId } = rowData;
    if (hardwareRequestInitiated && rowData.hardware.length && !existingHardwareRequest && !isNoRecommendationCase) {
      // when there is no existing requested data
      const addedMaterialsData = addedMaterials.filter((e) => e.subscriptionId === subscriptionId);

      const rows = hardware.map((item, itemIndex) => {
        const { isActionable = false, savedMaterial, subscriptionId } = item;
        const materials = requestedMaterialList[Number(subscriptionId)] || [];
        if (!isActionable || (isActionable && (selectedMaterialsFromDropdown[item.id] || savedMaterial))) {
          const options = [
            { value: "selectHardware", label: "Select Hardware" },
            ...materials.map((m) => {
              return { value: m.materialId, label: `${m.materialName} (${m.materialId})` };
            }),
          ];

          return (
            <div key={item.id} style={{ width: "328px", marginBottom: "10px", ...(itemIndex !== 0 ? { marginTop: "10px" } : {}) }}>
              <CustomisedDropdown
                key={item.id}
                options={options}
                onChange={(e) => {
                  setRequestedHardwareFromDropdown((prev) => {
                    return {
                      ...prev,
                      [item.id]: e.value,
                    };
                  });
                }}
                filter
                filterBy="label,value"
                value={requestedHardwareFromDropdown[item.id] || "selectHardware"}
                className="my-custom-dropdown"
                style={{
                  width: "100%",
                  color: "black",
                  fontSize: "16px",
                  fontFamily: "Verizon-NHG-eDS",
                  borderRadius: "0px",
                  borderWidth: "0.0625rem",
                  borderStyle: "solid",
                  borderColor: "rgb(216, 218, 218) rgb(216, 218, 218) rgb(0, 0, 0)",
                }}
              />
            </div>
          );
        } else {
          return "";
        }
      });

      rows.push(
        ...addedMaterialsData.map((addedItem) => {
          return (
            <div key={addedItem.id} style={{ width: "328px", marginBottom: "10px", marginTop: "10px" }}>
              <div style={{ padding: "12px", fontFamilt: "Verizon-NHG-eDS", minheight: "44px", backgroundColor: "#fff" }}>
                {addedItem.materialName} ({addedItem.materialId})
              </div>
            </div>
          );
        })
      );
      return rows;
    } else if (existingHardwareRequest) {
      const requestedMaterials = existingHardwareRequest.requestedHardwareMapping.filter((e) => e.subscriptionId == subscriptionId);
      return requestedMaterials.map((item, itemIndex) => {
        return (
          <div key={item.id} style={{ width: "328px", marginBottom: "10px", ...(itemIndex !== 0 ? { marginTop: "10px" } : {}) }}>
            <div style={{ padding: "12px", fontFamilt: "Verizon-NHG-eDS", minheight: "44px", backgroundColor: "#fff" }}>
              {item.materialName} ({item.materialId})
            </div>
          </div>
        );
      });
    }
    return "";
  };

  const renderApprovedChanges = (rowData) => {
    if (existingHardwareRequest && existingHardwareRequest?.approvedHardwareMapping?.length) {
      const { subscriptionId } = rowData;
      const approvedHardware = existingHardwareRequest.approvedHardwareMapping.filter((e) => e.subscriptionId === subscriptionId);
      if (approvedHardware.length > 0) {
        return approvedHardware.map((item, itemIndex) => (
          <div key={itemIndex} style={{ marginTop: "12px", marginBottom: "12px", fontFamilt: "Verizon-NHG-eDS", height: "44px" }}>
            {`${item.materialName} (${item.materialId})`}
          </div>
        ));
      }
    }
    if (hardwareRequestInitiated) {
      return rowData.hardware.map((item, itemIndex) => {
        return (
          <div key={itemIndex} style={{ marginTop: "12px", marginBottom: "12px", fontFamilt: "Verizon-NHG-eDS", height: "44px" }}>
            --
          </div>
        );
      });
    }
  };

  const onStartRequestClick = async () => {
    if (isCriticalFieldsChanged) {
      notify("Please save your changes before starting request", "error");
      return;
    }
    setHardwareRequestInitiated(true);
    if (!isNoRecommendationCase) {
      //set requested hardware to current hardware
      const subscriptionList = [...new Set(vehicleDetails.materialMapping.map((e) => e.subscriptionId))];
      const contractDetailsPromises = subscriptionList.map((subId) => getContractDetails(subId, cspInfo?.data?.data?.CSP?.[0]?.Opp_Sales_Org));
      const contractDetailsResponses = await Promise.all(contractDetailsPromises);
      const requestedMaterialList = contractDetailsResponses.reduce((acc, res) => {
        const filteredMaterials = res?.data?.data
          .filter((item) => String(item.materialId).startsWith("11") && !item.isObsolete)
          .sort((a, b) => String(a.materialId).localeCompare(String(b.materialId)));
        if (res?.status === 200 && filteredMaterials?.length) {
          acc[filteredMaterials[0].sapId] = filteredMaterials.map((e) => ({
            materialId: e.materialId,
            materialName: e.materialName,
            subscriptionId: e.sapId,
            subscriptionName: e.contractName,
            techRefId: vehicleDetails.materialMapping.find((v) => v.subscriptionId === e.sapId)?.techRefId || null,
          }));
        }
        return acc;
      }, {});
      setRequestedMaterialList(requestedMaterialList);
      const requestedHardwareMap = vehicleDetails.materialMapping.reduce((acc, cur) => {
        const { isActionable = false, savedMaterial, materials, id, subscriptionId } = cur;
        if (isActionable && (selectedMaterialsFromDropdown[id] || savedMaterial)) {
          // filtering non selected in requested hardware
          const materialId = selectedMaterialsFromDropdown[id] || savedMaterial || materials[0].materialId;
          const isMaterialExists = (requestedMaterialList[Number(subscriptionId)] || []).some((m) => m.materialId === materialId);
          acc[id] = isMaterialExists ? materialId : "selectHardware";
        } else if (!isActionable && !!materials[0].materialId) {
          const materialId = materials[0].materialId;
          const isMaterialExists = (requestedMaterialList[Number(subscriptionId)] || []).some((m) => m.materialId === materialId);
          acc[id] = isMaterialExists ? materialId : "selectHardware";
        }
        return acc;
      }, {});
      setRequestedHardwareFromDropdown(requestedHardwareMap);
      setVehicleDetails((prev) => ({ ...prev, vehicleStatus: "Warning" }));
    }
  };

  const renderRequestButtonAndStatus = () => {
    if (!hardwareRequestInitiated && !existingHardwareRequest && !isStartRequestDisabled) {
      return (
        <Button
          style={{ marginLeft: "0.5rem" }}
          role="button"
          size="small"
          variant="secondary"
          aria-label="StartRequest"
          data-testid="start-request-button"
          disabled={isLoading || isTableLoading}
          aria-disabled={isLoading || isTableLoading}
          onClick={() => onStartRequestClick()}
        >
          Start Request
        </Button>
      );
    } else if (hardwareRequestInitiated && (!existingHardwareRequest || existingHardwareRequest?.status === "CREATED")) {
      return (
        <span style={{ display: "flex" }}>
          <Button
            style={{ marginLeft: "0.5rem" }}
            role="button"
            size="small"
            variant="secondary"
            aria-label="Cancel"
            data-testid="cancel-request-button"
            disabled={isLoading || isTableLoading} // disable if the request status is not created and then make api call
            aria-disabled={isLoading || isTableLoading}
            onClick={() => {
              updateHardwareRequestHandler("USER_CANCEL");
            }}
          >
            Cancel
          </Button>
          <Button
            style={{ marginLeft: "0.5rem" }}
            role="button"
            size="small"
            variant="secondary"
            aria-label="SendRequest"
            data-testid="send-request-button"
            disabled={
              !!existingHardwareRequest ||
              !(!isNoRecommendationCase
                ? isRequestedHardwareChanged && reasonForChangingRecommendation.trim() !== "" && hardwareChangeComment.trim() !== ""
                : hardwareChangeComment.trim() !== "")
            }
            aria-disabled={
              !!existingHardwareRequest ||
              !(!isNoRecommendationCase
                ? isRequestedHardwareChanged && reasonForChangingRecommendation.trim() !== "" && hardwareChangeComment.trim() !== ""
                : hardwareChangeComment.trim() !== "")
            }
            onClick={createHardwareRequestHandler}
          >
            Send Request
          </Button>
        </span>
      );
    }
  };

  //existing hardware map for add materils
  const existingHardwareMap = useMemo(() => {
    if (requestedHardwareFromDropdown && Object.keys(requestedHardwareFromDropdown).length > 0) {
      const subscriptionMaterialMap = vehicleDetails.materialMapping.reduce((acc, item) => {
        const { id, subscriptionId } = item;
        if (requestedHardwareFromDropdown[id]) {
          if (!acc[subscriptionId]) {
            acc[subscriptionId] = [requestedHardwareFromDropdown[id]];
          } else {
            acc[subscriptionId].push(requestedHardwareFromDropdown[id]);
          }
        }
        return acc;
      }, {});
      return subscriptionMaterialMap;
    }
    return {};
  }, [requestedHardwareFromDropdown]);

  return (
    <>
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "400",
              color: "black",
            }}
            onClick={() => {
              handleChangePage({ index: 0 });
              messageBus.trigger("closeAccordions");
            }}
          >
            Assign Hardware
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem key={1} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
          >
            Vehicle Details
          </span>
        </BreadcrumbItem>
      </Breadcrumbs>
      <br />
      <div style={{ position: "relative" }}>
        {isLoading ? (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 100,
            }}
          >
            <Loader active={true} size="large" />
          </div>
        ) : (
          <>
            <Grid colSizes={{ mobile: 5, tablet: 5, desktop: 2.5 }} css={{ overflow: "hidden" }} style={{ margin: 0 }}>
              <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
                <Col css={{ flex: 4, display: "flex", flexDirection: "column", paddingLeft: 0 }}>{notification}</Col>
              </Row>
              <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
                <Col css={{ flex: 4, display: "flex", flexDirection: "column", paddingLeft: 0 }}>
                  <div style={{ fontWeight: "bold", fontSize: "1.5rem", fontFamily: "Arial, sans-serif", color: "black" }}>
                    {data.vehicle.startsWith("AST")
                      ? "Asset"
                      : data.displayVinId
                      ? `${data.vehicle} - ${data.year} ${data.make} ${data.model}`
                      : `${data.year} ${data.make} ${data.model}`}
                    {/* Show weightClass if present */}
                    {(data.weightClass || data.wheelChair || data.killSwitch || data.emergency) && (
                      <span
                        style={{
                          color: "#1E1E1E",
                          padding: "2px 2px",
                          marginLeft: 8,
                          display: "inline-flex", // changed to inline-flex for horizontal layout
                          alignItems: "center",
                          gap: "6px", // space between icons and weightClass
                          fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "11px",
                          lineHeight: "16px",
                          letterSpacing: "0px", // 0px
                          textAlign: "left",
                          textTransform: "none", // No text transformation
                          verticalAlign: "middle",
                        }}
                      >
                        {data.weightClass}
                        {/* Traits icons side by side */}
                        {data.wheelChair && (
                          <Icon
                            className="InternationalSymbolOfAccess"
                            aria-label="InternationalSymbolOfAccess"
                            alt="InternationalSymbolOfAccess"
                            name="international-symbol-of-access"
                            size="Large"
                            color="#000000"
                            style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle" }}
                          />
                        )}
                        {data.emergency && (
                          <Icon
                            className="police-fleet"
                            aria-label="police-fleet"
                            alt="police-fleet"
                            name="police-fleet"
                            size="Large"
                            color="#000000"
                            style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle" }}
                          />
                        )}
                        {data.killSwitch && (
                          <Icon
                            className="smart-switch"
                            aria-label="smart-switch"
                            alt="smart-switch"
                            name="smart-switch"
                            size="Large"
                            color="#000000"
                            style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle" }}
                          />
                        )}
                      </span>
                    )}
                    {/* Badge for vehicleStatus */}
                    {vehicleDetails.vehicleStatus &&
                      (vehicleDetails.vehicleStatus.toLowerCase() === "ready" || vehicleDetails.vehicleStatus.toLowerCase() === "warning") && (
                        <span
                          style={{
                            background: vehicleDetails.vehicleStatus.toLowerCase() === "ready" ? "#008330" : "#EE0000",
                            color: "#FFFFFF",
                            borderRadius: "2px",
                            padding: "2px 4px",
                            fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                            fontSize: "12px",
                            fontWeight: 700,
                            marginLeft: 12,
                            display: "inline-flex",
                            verticalAlign: "middle",
                            alignItems: "center",
                            lineHeight: "16px",
                            letterSpacing: "0px",
                          }}
                        >
                          {vehicleDetails.vehicleStatus.toLowerCase() === "ready" ? "Ready" : "Needs Attention"}
                        </span>
                      )}
                  </div>
                </Col>
                <Col css={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    style={{ marginLeft: "0.5rem" }}
                    role="button"
                    size="small"
                    variant="secondary"
                    data-testid="save-button"
                    aria-label="saveButton"
                    // --- MODIFIED LOGIC START ---
                    disabled={
                      isLoading ||
                      isSaving ||
                      (!isDoNotShipChanged &&
                        (!(
                          isCriticalFieldsChanged ||
                          (data.priority === null && data.deviceType !== "ASSET" && data.deviceType !== "KEYFOB") ||
                          (!existingHardwareRequest &&
                            vehicleDetails.vehicleStatus === "Warning" &&
                            (materialsAndPriorities
                              ? !materialsAndPriorities
                                  .find((device) => device.deviceType === hardwareSelected)
                                  ?.recommendations?.filter((e) => e.isActionable).length
                              : false))
                        ) ||
                          (!existingHardwareRequest &&
                            !data.vehicle.startsWith("AST") &&
                            (!hardwareSelected ||
                              hardwareSelected === "" ||
                              (hardwareSelected &&
                                hardwares.find((h) => h.value === hardwareSelected)?.priority !== 1 &&
                                (!reasonSelected || reasonSelected === "Select Reason")))) ||
                          !contact ||
                          contact.trim() === "" ||
                          !phone ||
                          phone.trim() === "" ||
                          !email ||
                          email.trim() === "" ||
                          address.historicalAddress.value === "Please select an address or choose Add New to add a new address" ||
                          (address.historicalAddress.value === "Add New" && !address.verified) ||
                          (!existingHardwareRequest &&
                            Object.keys(selectedMaterialsFromDropdown).length !==
                              materialsAndPriorities
                                ?.find((device) => device.deviceType === hardwareSelected)
                                ?.recommendations?.filter((e) => e.isActionable).length)))
                    }
                    aria-disabled={
                      isLoading ||
                      isSaving ||
                      (!isDoNotShipChanged &&
                        (!(
                          isCriticalFieldsChanged ||
                          (data.priority === null && data.deviceType !== "ASSET" && data.deviceType !== "KEYFOB") ||
                          (!existingHardwareRequest &&
                            vehicleDetails.vehicleStatus === "Warning" &&
                            (materialsAndPriorities
                              ? !materialsAndPriorities
                                  .find((device) => device.deviceType === hardwareSelected)
                                  ?.recommendations?.filter((e) => e.isActionable).length
                              : false))
                        ) ||
                          (!existingHardwareRequest &&
                            !data.vehicle.startsWith("AST") &&
                            (!hardwareSelected ||
                              hardwareSelected === "" ||
                              (hardwareSelected &&
                                hardwares.find((h) => h.value === hardwareSelected)?.priority !== 1 &&
                                (!reasonSelected || reasonSelected === "Select Reason")))) ||
                          !contact ||
                          contact.trim() === "" ||
                          !phone ||
                          phone.trim() === "" ||
                          !email ||
                          email.trim() === "" ||
                          address.historicalAddress.value === "Please select an address or choose Add New to add a new address" ||
                          (address.historicalAddress.value === "Add New" && !address.verified) ||
                          (!existingHardwareRequest &&
                            Object.keys(selectedMaterialsFromDropdown).length !==
                              materialsAndPriorities
                                ?.find((device) => device.deviceType === hardwareSelected)
                                ?.recommendations?.filter((e) => e.isActionable).length)))
                    }
                    // --- MODIFIED LOGIC END ---
                    onClick={handleClick}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
              <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "15px" }}>
                <Col css={{ flex: 1, display: "flex", flexDirection: "column", position: "relative", paddingLeft: 0 }}>
                  <div style={{ position: "sticky", top: 0 }}>
                    <EditVehicleValidateAddress
                      setModalOpened={setModalOpened}
                      setAlertModal={setAlertModal}
                      address={address}
                      setAddress={setAddress}
                      vehicleData={vehicleData}
                      showHistoricalAddressDropdown={true}
                      setIsLoading={setIsLoading}
                      notify={notify}
                      shippingAddress={
                        !isFieldsChanged
                          ? [
                              bundleData.address,
                              bundleData.address1 ? bundleData.address1 : null,
                              bundleData.city,
                              bundleData.stateCode,
                              bundleData.zipCode,
                              bundleData.countryCode,
                            ]
                              .filter((item) => item !== null && item !== "")
                              .join(", ")
                          : [
                              address.address1.value,
                              address.address2.value,
                              address.city.value,
                              address.state.value?.erpStateCode,
                              address.zip.value,
                              address.country.value?.code,
                            ]
                              .filter((item) => item !== null && item !== "")
                              .join(", ")
                      }
                      onFieldsChanged={(changed) => setIsFieldsChanged(changed)}
                    />
                    <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "3px" }}>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <div style={{ fontSize: "0.75rem", fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif", color: "black" }}>
                          Vehicle Comments
                        </div>
                        <div
                          style={{
                            marginTop: "0.5rem",
                            color: "black",
                            border: "1px solid #D8DADA",
                            height: "88px",
                            weight: "670px",
                            overflowY: "auto",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "1rem",
                              padding: "12px",
                              fontWeight: 400,
                              fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif",
                            }}
                          >
                            {hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority !== 1 ? "" : commentText ?? ""}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col css={{ flex: 1, display: "flex", flexDirection: "column", alignSelf: "flex-start" }}>
                  <div style={{ position: "sticky", top: 0 }}>
                    <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column", paddingLeft: 0 }}>
                        <Input
                          style={{ width: "100%" }}
                          type="text"
                          name="Contact"
                          onChange={(e) => setContact(e.target.value)}
                          value={contact}
                          label="Contact *"
                          error={false}
                        />
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <Input
                          style={{ width: "100%" }}
                          type="text"
                          name="Contact"
                          onChange={(e) => setPhone(e.target.value)}
                          value={phone}
                          label="Phone *"
                          error={false}
                        />
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <Input
                          style={{ width: "100%" }}
                          type="text"
                          name="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                          label="Email *"
                          error={false}
                        />
                      </Col>
                    </Row>
                    <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "3px" }}>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <DropdownSelect
                          style={{ width: "100%" }}
                          label={"Hardware *"}
                          value={hardwareSelected || ""}
                          onChange={(e) => {
                            const newHardwareValue = e.target.value;
                            if (!data.vehicle.startsWith("AST")) {
                              const oldHardware = hardwares.find((h) => h.value === hardwareSelected);
                              const newHardware = hardwares.find((h) => h.value === newHardwareValue);

                              if (oldHardware && newHardware && oldHardware.priority !== newHardware.priority) {
                                if (oldHardware.priority !== 1 && reasonSelected && reasonSelected !== "Select Reason") {
                                  reasonForNonPriority1Ref.current = reasonSelected;
                                }
                                if (newHardware.priority !== 1) {
                                  setReasonSelected(reasonForNonPriority1Ref.current || null);
                                } else if (originalFormValues) {
                                  setReasonSelected(originalFormValues.reason);
                                }
                                setIsTableLoading(true);

                                if (materialsAndPriorities && materialsAndPriorities.length > 0) {
                                  const selectedDeviceData = materialsAndPriorities?.find((device) => device.deviceType === newHardware.value);

                                  if (selectedDeviceData && selectedDeviceData.recommendations) {
                                    setTimeout(() => {
                                      const updatedMaterialMapping = selectedDeviceData.recommendations;
                                      setVehicleDetails((prev) => {
                                        return {
                                          ...prev,
                                          materialMapping: updatedMaterialMapping,
                                        };
                                      });
                                      setIsStartRequestDisabled(updatedMaterialMapping.every((item) => item.status?.toLowerCase() === "submitted"));
                                      setIsTableLoading(false);
                                    }, 1500);
                                  } else {
                                    setIsTableLoading(false);
                                  }
                                } else {
                                  setIsTableLoading(false);
                                }
                              }
                            }
                            setSelectedMaterialsFromDropdown({});
                            setHardwareSelected(newHardwareValue);
                          }}
                          disabled={
                            isLoading ||
                            data.vehicle.startsWith("AST") ||
                            hardwareRequestInitiated ||
                            existingHardwareRequest ||
                            hasNoValidRecommendations()
                          }
                        >
                          {hardwares.map((item) => {
                            return (
                              <option key={item.id} value={item.value} disabled={item.value === "Select"}>
                                {item.label}
                              </option>
                            );
                          })}
                        </DropdownSelect>
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <DropdownSelect
                          style={{ width: "100%" }}
                          label={
                            data.vehicle.startsWith("AST")
                              ? "Reason"
                              : hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority === 1
                              ? "Reason"
                              : "Reason *"
                          }
                          value={reasonSelected || "Select Reason"}
                          onChange={(e) => {
                            setReasonSelected(e.target.value);
                          }}
                          disabled={
                            isLoading ||
                            data.vehicle.startsWith("AST") ||
                            (hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority === 1) ||
                            hardwareRequestInitiated ||
                            existingHardwareRequest ||
                            hasNoValidRecommendations()
                          }
                        >
                          <option disabled>Select Reason</option>
                          {reasons.map((item) => {
                            return (
                              <option key={item.id} value={item.value} disabled={item.value === "Select"}>
                                {item.label}
                              </option>
                            );
                          })}
                        </DropdownSelect>
                      </Col>
                      <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <div style={{ fontSize: "0.75rem", fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif", color: "black" }}>
                          Vehicle Status | Priority
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "0.5rem",
                          }}
                        >
                          <div style={{ fontSize: "0.75rem", fontFamily: "Verizon-NHG-eTX, Helvetica, Ariel, sans-serif", color: "black" }}>
                            {data.vehicle.startsWith("AST")
                              ? `${vehicleDetails.vehicleStatus === "Warning" ? "Needs Attention" : vehicleDetails.vehicleStatus} | Recommended`
                              : `${vehicleDetails.vehicleStatus === "Warning" ? "Needs Attention" : vehicleDetails.vehicleStatus} | ${
                                  hardwareSelected && hardwares.find((h) => h.value === hardwareSelected)?.priority === 1
                                    ? "Recommended"
                                    : "Specified"
                                }`}
                          </div>
                        </div>
                        <StyledCheckbox
                          selected={doNotShipCheckboxSelected}
                          role="checkbox"
                          aria-checked={doNotShipCheckboxSelected}
                          type="checkbox"
                          name="default"
                          width="auto"
                          onChange={() => {
                            setDoNotShipCheckboxSelected(!doNotShipCheckboxSelected);
                          }}
                        >
                          Do Not Ship
                        </StyledCheckbox>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row
                css={{
                  flexDirection: "row",
                  justifyContent: "start",
                  display: "flex !important",
                  flex: 1,
                  marginTop: "20px",
                  // overflow: "hidden",
                }}
              >
                <Col
                  css={{
                    flex: 5,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    // overflow: "hidden",
                    paddingLeft: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      overflow: "visible",
                      width: "1626px",
                    }}
                  >
                    <div style={{ flexDirection: "row", display: "flex" }}>
                      <div
                        style={{
                          fontWeight: "bold",
                          marginBottom: "10px",
                          fontSize: "1.1rem",
                          fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                          color: "black",
                          ...(existingHardwareRequest ? { width: "865px" } : { flex: 1 }),
                        }}
                      >
                        {`${bundleName} (${bundleId})`}
                      </div>
                      {existingHardwareRequest ? (
                        <div style={{ fontWeight: 700, flex: 1 }}>
                          Request# {existingHardwareRequest.id} - {HARDWARE_REQUEST_STATUS[existingHardwareRequest.status]}
                        </div>
                      ) : (
                        <></>
                      )}
                      <div>{renderRequestButtonAndStatus()}</div>
                    </div>

                    {!vehicleDetails.materialMapping.length ? (
                      <div
                        style={{
                          fontSize: "0.8rem",
                          fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                          color: "black",
                          padding: "10px 0",
                          fontWeight: "normal",
                        }}
                      >
                        No Material mapping found
                      </div>
                    ) : (
                      <div
                        style={{
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          maxHeight: "900px",
                          fontSize: "0.75rem",
                          fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                          width: "1626px",
                        }}
                      >
                        {isTableLoading && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 10,
                            }}
                          >
                            <Loader active={true} size="medium" />
                          </div>
                        )}

                        <div
                          style={{
                            position: "sticky",
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 2,
                            borderBottom: "1px solid #d8dada",
                            display: "flex",
                          }}
                        >
                          {BUNDLE_LIST.map((column, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "8px 16px",
                                textAlign: "left",
                                fontWeight: "700",
                                fontSize: "0.75rem",
                                color: "#6F7171",
                                flex: column.width || 1,
                                overflow: "visible",
                                boxSizing: "border-box",
                                height: "auto",
                                wordBreak: "break-word",
                              }}
                            >
                              {column.key}
                            </div>
                          ))}
                        </div>
                        <div
                          style={{
                            overflowY: "auto",
                            flex: 1,
                            minHeight: 0,
                          }}
                        >
                          {subscriptionTableBody.map((rowData, index) => {
                            const { type, subscriptionId, subscriptionName, techRefId } = rowData;

                            return (
                              <div
                                key={subscriptionId}
                                style={{
                                  display: "flex",
                                  borderBottom: "1px solid #eee",
                                  backgroundColor: type.toLowerCase() === "core" ? "#E3F2FD" : index % 2 === 0 ? "#F6F6F6" : "#D8DADA",
                                }}
                              >
                                <div
                                  key={0}
                                  style={{
                                    padding: "16px",
                                    fontSize: "0.75rem",
                                    flex: 0.2,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {type && type !== "--" ? (
                                    <span style={{ padding: "2px 4px", borderRadius: "2px", fontWeight: 700, ...BADGE_STYLE[type.toLowerCase()] }}>
                                      {type}
                                    </span>
                                  ) : (
                                    "--"
                                  )}
                                </div>
                                <div
                                  key={1}
                                  style={{
                                    padding: "16px",
                                    fontSize: "0.75rem",
                                    flex: 0.5,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  {subscriptionName ? (
                                    <>
                                      <div style={{ color: "black", fontWeight: 700 }}>{subscriptionName}</div>
                                      <div style={{ color: "#6F7171", paddingTop: "4px" }}>Subscription ID: {subscriptionId}</div>
                                      <div style={{ color: "#6F7171", paddingTop: "4px" }}>
                                        Tech Ref: {techRefId ? techRefId.replace(".", "-") : techRefId}
                                      </div>
                                    </>
                                  ) : (
                                    "—"
                                  )}
                                </div>
                                <div
                                  key={2}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 1,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderHardwareDetails(rowData)}
                                </div>
                                <div
                                  key={3}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.8,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderRequestedardware(rowData)}
                                </div>
                                <div
                                  key={4}
                                  style={{
                                    padding: "16px",
                                    fontSize: "1rem",
                                    color: "black",
                                    flex: 0.8,
                                    overflow: "visible",
                                    boxSizing: "border-box",
                                    height: "auto",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderApprovedChanges(rowData)}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              {hardwareRequestInitiated ? (
                <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex", flex: 1, marginTop: "8px" }}>
                  <Col css={{ flex: 1 }}>
                    <div style={{ display: "flex", flexDirection: "row", width: "1626px", justifyContent: "flex-end" }}>
                      <div style={{ flex: 0.2 }}></div>
                      <div style={{ flex: 0.5 }}></div>
                      <div style={{ flex: 1 }}></div>
                      <div style={{ flex: 0.7 }}>
                        {/* disable when req already made and no recommendation */}
                        {!isNoRecommendationCase ? (
                          <>
                            <div
                              style={{
                                fontWeight: 700,
                                textDecoration: "underline",
                                fontSize: "12px",
                                ...(existingHardwareRequest ? { pointerEvents: "none", opacity: 0.6 } : { cursor: "pointer" }), // no recommendation
                              }}
                              tabIndex={existingHardwareRequest ? -1 : 0}
                              aria-disabled={!!existingHardwareRequest}
                              onClick={() => {
                                if (!existingHardwareRequest) setIsAddMaterialModalOpen(true);
                              }}
                            >
                              Add Material
                            </div>

                            <div style={{ marginTop: "16px", width: "328px", fontFamily: "Verizon-NHG-eTX" }}>
                              {existingHardwareRequest ? (
                                <>
                                  <lable>Reason for Changing*</lable>
                                  <div style={{ height: "44px", border: "1px solid #D8DADA", borderRadius: "4px", padding: "12px" }}>
                                    {reasonForChangingRecommendation}
                                  </div>
                                </>
                              ) : (
                                <DropdownSelect
                                  style={{ width: "100%" }}
                                  label={"Reason for Changing*"}
                                  value={reasonForChangingRecommendation || "Select Reason"}
                                  onChange={(e) => {
                                    setReasonForChangingRecommendation(e.target.value);
                                  }}
                                  disabled={isLoading || isTableLoading || !isRequestedHardwareChanged} // enable when there is change in requested hardware
                                >
                                  <option disabled>Select Reason</option>
                                  {reasons.map((item) => {
                                    return (
                                      <option key={item.id} value={item.labels} disabled={item.value === "Select"}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </DropdownSelect>
                              )}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        <div style={{ marginTop: "8px", width: "328px", fontFamily: "Verizon-NHG-eTX" }}>
                          {/* add disable logic and set field afetr api call */}
                          {existingHardwareRequest ? (
                            <>
                              <lable>Comments*</lable>
                              <div style={{ height: "88px", border: "1px solid #D8DADA", borderRadius: "4px", padding: "12px" }}>
                                {hardwareChangeComment}
                              </div>
                            </>
                          ) : (
                            <TextArea
                              label="Comments*"
                              aria-label="Comments*"
                              required={true}
                              maxLength={200}
                              value={hardwareChangeComment}
                              onChange={(e) => setHardwareChangeComment(e.target.value)}
                              css={{
                                fontSize: "12px",
                                fontFamily: "Verizon-NHG-eTX",
                                letterSpacing: "0",
                              }}
                              disabled={isLoading || isTableLoading || (!isNoRecommendationCase && !isRequestedHardwareChanged)} // enable when there is change in requested hardware
                            />
                          )}
                        </div>
                        <div style={{ marginTop: "8px", fontSize: "12px", fontFamily: "Verizon-NHG-eTX" }}>
                          If you have a backup documentation, then use attachment below.
                        </div>
                      </div>
                      <div style={{ flex: 0.8 }}>
                        {/* show approval comment only once the request has reached final state */}
                        {existingHardwareRequest?.approvalComments && existingHardwareRequest.approvalComments !== "" ? (
                          <div style={{ fontWeight: 700, paddingBottom: "8px", fontSize: "12px" }}>
                            Comments: {existingHardwareRequest.approvalComments}
                          </div>
                        ) : (
                          <></>
                        )}
                        {isNoRecommendationCase ? (
                          <></>
                        ) : (
                          <div
                            style={{
                              marginTop: "8px",
                              display: "flex",
                            }}
                          >
                            <Button
                              role="button"
                              size="small"
                              variant="primary"
                              aria-label="Accept Hardware"
                              data-testid="accept-hardware-button"
                              disabled={existingHardwareRequest ? !["MODIFIED_PENDING_AGENT"].includes(existingHardwareRequest.status) : true} // enable once req status is pending agent
                              aria-disabled={true}
                              primary
                              onClick={() => updateHardwareRequestHandler("USER_ACCEPT")}
                            >
                              Accept Hardware
                            </Button>
                            <Button
                              style={{ marginLeft: "0.5rem" }}
                              role="button"
                              size="small"
                              aria-label="Use Current Recommendation"
                              data-testid="use-current-recommendation-button"
                              disabled={
                                existingHardwareRequest
                                  ? !["MODIFIED_PENDING_AGENT", "REVERTED_PENDING_AGENT"].includes(existingHardwareRequest.status)
                                  : true
                              } // enable once the req is in pending Agent state
                              aria-disabled={true}
                              secondary
                              onClick={() => updateHardwareRequestHandler("USER_USE_CURRENT")}
                            >
                              Use Current Recommendation
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Grid>

            <div>
              <VehicleImageUpload
                onImagesChange={handleFileUpload}
                onFileUpload={handleFileUpload}
                vehicleId={data.vehicle}
                bundleId={bundleId}
                setIsLoading={setIsLoading}
                showCustomAlert={notify}
                RETRIEVE_BASE_URL={retrieveBundleFiles}
              />
            </div>
          </>
        )}
        {isAddMaterialModalOpen && (
          <AddMaterial
            isOpen={isAddMaterialModalOpen}
            onClose={() => {
              setIsAddMaterialModalOpen(false);
            }}
            recommendations={vehicleDetails.materialMapping} //filter already selected requested hardwares
            handleAddMaterial={(addedMaterials) => {
              setAddedMaterials(addedMaterials);
            }}
            addedMaterials={addedMaterials}
            existingHardwareMap={existingHardwareMap}
            materialList={requestedMaterialList}
          />
        )}
      </div>
    </>
  );
};

export default EditVehicleWTAComponent;
